var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as Color from 'color';
import { wixStylesFontUtils } from './wixStylesFontUtils';
import { isJsonLike, parseJson } from './utils';
var hexColorRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
var getNormalizedContrast = function (color1, color2) {
    var contrast = color1.contrast(color2);
    if (contrast < 1) {
        contrast = 1 / contrast;
    }
    return contrast;
};
export var defaultPlugins = {
    join: function (color1, strength1, color2, strength2) {
        color1 = new Color(color1);
        color2 = new Color(color2);
        //todo: use strength
        //let color1strength = args[1];
        //let color2strength = args[3];
        var r = ((color1.red() / 255 + color2.red() / 255) * 255);
        var g = ((color1.green() / 255 + color2.green() / 255) * 255);
        var b = ((color1.blue() / 255 + color2.blue() / 255) * 255);
        var a = ((color1.alpha() + color2.alpha()) / 2);
        return new Color({ r: r, g: g, b: b }).alpha(a).rgb().string();
    },
    color: function (colorValue, tpaParams) {
        if (tpaParams.colors[colorValue]) {
            return tpaParams.colors[colorValue];
        }
        try {
            if (hexColorRegex.test(colorValue)) {
                return colorValue;
            }
            else if (colorValue) {
                return new Color(colorValue).rgb().string();
            }
            else {
                return '';
            }
        }
        catch (e) {
            throw new Error("Unparsable color " + colorValue);
        }
    },
    font: function (font, tpaParams) {
        var fontValue;
        if (typeof font === 'object') {
            fontValue = font;
        }
        else if (isJsonLike(font)) {
            var _a = parseJson(font), theme = _a.theme, overrides = __rest(_a, ["theme"]);
            fontValue = __assign(__assign({ style: '', variant: '', weight: '', stretch: '', size: '', lineHeight: '', family: [] }, tpaParams.fonts[theme]), overrides);
        }
        else if (tpaParams.fonts[font]) {
            fontValue = tpaParams.fonts[font];
        }
        else {
            return font;
        }
        var fontCssValue = wixStylesFontUtils.toFontCssValue(fontValue);
        if (fontCssValue[fontCssValue.length - 1] === ';') {
            fontCssValue = fontCssValue.split(';')[0];
        }
        else {
            //todo: else never reached
        }
        return fontCssValue;
    },
    opacity: function (color, opacity) {
        return (new Color(color)).fade(1 - opacity).rgb().string();
    },
    withoutOpacity: function (color) {
        return (new Color(color)).alpha(1).rgb().string();
    },
    string: function (value) {
        return value;
    },
    darken: function (colorVal, darkenValue) {
        return (new Color(colorVal)).darken(darkenValue).rgb().string();
    },
    number: function (value) {
        return +value;
    },
    underline: function (font) {
        return font && font.underline ? 'underline' : '';
    },
    unit: function (value, unit) {
        return "" + value + unit;
    },
    fallback: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var argsWithoutTPAParams = args.slice(0, -1);
        return argsWithoutTPAParams.filter(Boolean)[0];
    },
    zeroAsTrue: function (zero) {
        return (typeof zero === 'number') ? "" + zero : zero;
    },
    calculate: function (operator) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var numbersWithoutTPAParams = args.slice(0, -1);
        if (numbersWithoutTPAParams.length > 1) {
            return "calc(" + numbersWithoutTPAParams.join(" " + operator + " ") + ")";
        }
        else {
            return numbersWithoutTPAParams[0];
        }
    },
    readableFallback: function (baseColor, suggestedColor, fallbackColor) {
        var contrast = getNormalizedContrast(new Color(baseColor), new Color(suggestedColor));
        return contrast < 4.5 ? fallbackColor : suggestedColor;
    },
    smartBGContrast: function (foreground, background) {
        var color = new Color(foreground);
        var contrastColor = new Color(background);
        var baseLuminosity = color.luminosity();
        var originalContrastLuminosity = contrastColor.luminosity();
        var ratio = baseLuminosity / originalContrastLuminosity;
        var direction = ratio < 1 ? 1 : -1;
        var contrast = getNormalizedContrast(color, contrastColor);
        var luminositySteps = [1, 5, 10, 20, 30, 40, 50, 60];
        // tslint:disable-next-line:prefer-for-of
        for (var i = 0; i < luminositySteps.length; i++) {
            if (contrast < 4.5) {
                contrastColor = contrastColor.lightness(contrastColor.lightness() + (direction * luminositySteps[i]));
            }
            else {
                break;
            }
            contrast = getNormalizedContrast(color, contrastColor);
        }
        return contrastColor.rgb().string();
    }
};
//# sourceMappingURL=defaultPlugins.js.map